import React, { useCallback, useMemo, useState } from "react";
import cx from "classnames";
import { FolderWrapper } from "components";
import s from "objs/_ConfiguratorObjs/Wizard/WizardLeftSidebar/Extension/WizardLeftSidebarExtension.module.scss";
import { WizardEditableTitle } from "../../SubComponents/WizardEditableTitle";

export const WizardLeftSidebarItem = ({
  id,
  title,
  position,
  handleItemClick,
  currentQuestionnaireIdentifier,
  isUserActionsDisabled,
  step,
}) => {
  const [isEditMode, setEditMode] = useState(false);

  const handleToggleEditMode = useCallback(async () => {
    await handleItemClick(id);
    setEditMode((val) => !val);
  }, [handleItemClick, id]);

  const handleClick = useCallback(() => {
    handleItemClick(id);
  }, [handleItemClick, id]);

  const isActive = useMemo(
    () => id === currentQuestionnaireIdentifier,
    [id, currentQuestionnaireIdentifier],
  );

  return (
    <li
      className={cx("mt-2_5", {
        [s.zonesMenuFolderActive]: id === currentQuestionnaireIdentifier,
        [s.zonesMenuFolderDisabled]: isUserActionsDisabled,
      })}
      onClick={handleClick}
    >
      <FolderWrapper
        isRightStep={step === 2}
        zonesActive={isActive}
        className={cx(
          "border",
          s.wizardLeftSidebarExtFolder,
          s.zonesMenuFolder,
        )}
      >
        <div className="d-flex align-items-center justify-content-between w-100 h-100">
          <div
            className={cx(
              s.wizardLeftSidebarExtFolderData,
              "d-flex justify-content-between w-100 mw-100",
            )}
          >
            {isEditMode ? (
              <WizardEditableTitle
                title={title}
                zoneId={id}
                inputClassNames="ms-1 fw-bold"
                handleToggleEditMode={handleToggleEditMode}
              />
            ) : (
              <span
                className={cx(
                  "fw-bold ms-2 fs-md text-white overflow-x-hidden flex-1  d-flex align-items-center bg-opacity-5",
                )}
                onClick={handleToggleEditMode}
              >
                {title}
              </span>
            )}
            <span
              className={cx(
                s.wizardLeftSidebarExtFolderDataPosition,
                "text-white d-flex align-items-center justify-content-center position-relative",
              )}
            >
              {position.toString().padStart(3, "0")}
            </span>
          </div>
        </div>
      </FolderWrapper>
    </li>
  );
};
